const manufacturingActions = {
    CREATE_MANUFACTURING_DEVICES: 'CREATE_MANUFACTURING_DEVICES',
    CREATE_MANUFACTURING_DEVICES_SUCCESS: 'CREATE_MANUFACTURING_DEVICES_SUCCESS',
    CREATE_MANUFACTURING_DEVICES_ERROR: 'CREATE_MANUFACTURING_DEVICES_ERROR',

    FETCH_MANUFACTURING_DEVICES: 'FETCH_MANUFACTURING_DEVICES',
    FETCH_MANUFACTURING_DEVICES_SUCCESS: 'FETCH_MANUFACTURING_DEVICES_SUCCESS',
    FETCH_MANUFACTURING_DEVICES_ERROR: 'FETCH_MANUFACTURING_DEVICES_ERROR',

    FETCH_ALL_MANUFACTURING_DEVICES: 'FETCH_ALL_MANUFACTURING_DEVICES',
    FETCH_ALL_MANUFACTURING_DEVICES_SUCCESS: 'FETCH_ALL_MANUFACTURING_DEVICES_SUCCESS',

    EDIT_MANUFACTURING_DEVICE: 'EDIT_MANUFACTURING_DEVICE',
    EDIT_MANUFACTURING_DEVICE_SUCCESS: 'EDIT_MANUFACTURING_DEVICE_SUCCESS',
    createManufacturingDevices: (data) => {
        return {
            type: manufacturingActions.CREATE_MANUFACTURING_DEVICES,
            devices: data,
        }
    },
    createManufacturingDevicesSuccess: (devices) => {
        return {
            type: manufacturingActions.CREATE_MANUFACTURING_DEVICES_SUCCESS,
            devices
        }
    },
    fetchManufacturingDevices: (search) => {
        console.log('search info', search)
        return {
            type: manufacturingActions.FETCH_MANUFACTURING_DEVICES,
            search,
        }
    },
    fetchManufacturingDevicesSuccess: (devices) => {
        return {
            type: manufacturingActions.FETCH_MANUFACTURING_DEVICES_SUCCESS,
            devices,
        }
    },
    fetchAllManufacturingDevices: () => {
        return {
            type: manufacturingActions.FETCH_ALL_MANUFACTURING_DEVICES,
        }
    },
    fetchAllManufacturingDevicesSuccess: (devices) => {
        return {
            type: manufacturingActions.FETCH_ALL_MANUFACTURING_DEVICES_SUCCESS,
            devices,
        }
    },
    editManufacturingDevice: (data) => {
        return {
            type: manufacturingActions.EDIT_MANUFACTURING_DEVICE,
            device:data
        }
    },
    editManufacturingDeviceSuccess: (data) => {
        return {
            type: manufacturingActions.EDIT_MANUFACTURING_DEVICE_SUCCESS,
        }
    },
};
export default manufacturingActions
